export const DEFAULT_REQUEST_INTRO_MESSAGE_KEY = 'defaultRequestIntroMessage';
